<template>
  <div class="img-container">
    <v-img :width="300" aspect-ratio="16/9" src="../assets/logo.png"></v-img>
  </div>
  <div class="notfound-container">
    <div class="text-box">
      <h2>404 Not found. The page you are looking for does not exist.</h2>
    </div>
  </div>
</template>

<script>
export default {
  name: "404NotFound",
};
</script>
<style scoped>
.notfound-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
h2 {
  font-size: 40px;
}
.text-box {
  text-align: center;
  width: 100%;
}

.img-container {
  margin: 0 auto;
  position: relative;
  left: 50rem;
  padding-left: 16px;
  padding-top: 22px;
}
</style>
